<div
  [formGroup]="form"
  [patchFormGroupWithEmitValues]="config()"
  class="flex flex-col"
>
  <bo-widget-base-filter
    formControlName="filter"
    [showEnergySource]="false"
    [showHknTypes]="true"
    [customDateRangeLabel]="'costing.offer.fields.TRADING_DAYS_RANGE'"
  ></bo-widget-base-filter>

  <mat-checkbox formControlName="showSumRow">
    {{ 'market-hkn-customers.SHOW_SUM_ROW' | transloco }}
  </mat-checkbox>
</div>
